/**
 * @author      Dario Casertano <dario@casertano.name>
 * @copyright   Copyright (c) 2021-2023 Casertano Dario – All rights reserved.
 * @license     Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International.
 */

import { register } from 'register-service-worker'

register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
        console.log('[service-worker.js]', 'registered');

        document.dispatchEvent(new CustomEvent('sw.ready'));
    },
    registered(registration) {
        console.log('[service-worker.js]', 'registered');

        document.dispatchEvent(new CustomEvent('sw.registered', {detail: registration}));
    },
    cached(registration) {
        console.log('[service-worker.js]', 'cached');

        document.dispatchEvent(new CustomEvent('sw.cached', {detail: registration}));
    },
    updated(registration) {
        console.log('[service-worker.js]', 'updated');

        document.dispatchEvent(new CustomEvent('sw.updated', {detail: registration}));
    },
    updatefound(registration) {
        console.log('[service-worker.js]', 'updatefound');

        document.dispatchEvent(new CustomEvent('sw.updatefound', {detail: registration}));
    },
    offline() {
        console.log('[service-worker.js]', 'offline');

        document.dispatchEvent(new CustomEvent('sw.offline'));
    },
    error(error) {
        console.log('[service-worker.js]', error);

        document.dispatchEvent(new CustomEvent('sw.error', {detail: error}));
    },
});
